import React from 'react'

function HR_program_details() {
  return (
    <div>
      {/* -----------------Mobile view--------------------- */}
      <div className="d-sm-block d-md-none">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="text-center Program_details_1stcomp_text_mobile">
                <h1 className="display-6">Mastering in HR skills </h1>
                <p className="py-2">
                  Unlock your potential with our Human Resources programs.
                  Enroll now for a transformative journey, shaping your skills
                  for a brighter future in the dynamic world of HR.
                </p>
              </div>
              <div className="mt-4 text-center Program_details_1stcomp_text_mobile">
                <h1 className="display-4">Overview</h1>
                <p className="py-2">
                  In-depth study of Human Resource Management (HRM) will be
                  provided in this course. Examine all aspects of HR, including
                  performance management and recruiting and selection, with an
                  emphasis on current issues and emerging trends. Acquire vital
                  skills in employee engagement and HR analytics. Learn the
                  nuances of compensation and remuneration management, as well
                  as how to organize and formulate HR policies. Gain a deeper
                  comprehension of training, development, and manpower planning.
                  Set out on a life-changing educational journey that will
                  culminate in practical projects and equip you for a prosperous
                  HR career.
                </p>
              </div>
            </div>
            <div className="col-md-12">
              <div>
                <div className="Details_container shadow-lg px-1 py-4">
                  <h1 className="Details_text text-center  pb-2 border-bottom">
                    Human Resources
                  </h1>
                  <div className="Details_text">
                    <ul className="pt-2">
                      <li>Live conversations with industry professionals</li>
                      <li className="py-3">Project support and Guidance</li>
                      <li>Access to Specialized Course Materials</li>
                      <li className="py-3">25+ Hours of Learning</li>
                      <li>
                        Certificates from reputable MNC's around the world
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* -----------------Desktop View--------------------- */}
      <div className="d-none d-md-block">
        <div className="container">
          <div className="row">
            <div className="col-md-8 detail_1stcomp_img">
              <div className="pt-3 Program_details_1stcomp_text">
                <h1 className="fs-2">Mastering in HR skills </h1>
                <p className="py-2">
                  Unlock your potential with our Human Resources programs.
                  Enroll now for a transformative journey, shaping your skills
                  for a brighter future in the dynamic world of HR.
                </p>
              </div>
              <div className="mt-3 Program_details_1stcomp_text">
                <h1 className="display-4">Overview</h1>
                <p className="py-2">
                  In-depth study of Human Resource Management (HRM) will be
                  provided in this course. Examine all aspects of HR, including
                  performance management and recruiting and selection, with an
                  emphasis on current issues and emerging trends. Acquire vital
                  skills in employee engagement and HR analytics. Learn the
                  nuances of compensation and remuneration management, as well
                  as how to organize and formulate HR policies. Gain a deeper
                  comprehension of training, development, and manpower planning.
                  Set out on a life-changing educational journey that will
                  culminate in practical projects and equip you for a prosperous
                  HR career.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div>
                <div className="Details_container shadow-lg px-3 py-4">
                  <h1 className="Details_text text-center  pb-4 pt-3 border-bottom">
                    Human Resources
                  </h1>
                  <div className="Details_text ">
                    <ul className="pt-3">
                      <li>Live conversations with industry professionals</li>
                      <li className="py-3">Project support and Guidance</li>
                      <li>Access to Specialized Course Materials</li>
                      <li className="py-3">25+ Hours of Learning</li>
                      <li>
                        Certificates from reputable MNC's around the world
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HR_program_details
